<template class="text_google">
  <v-app>
    <v-system-bar class="d-print-none pt-3" height="30" app lights-out>
      <v-toolbar-items class="text-right">
        <v-btn
          large
          rounded
          dark
          href="javascript:window.print()"
          class="title mr-2 rounded"
          color="info"
        >
          <v-icon class="mr-1" color="white" large>mdi-printer</v-icon>พิมพ์
        </v-btn>

        <v-btn
          @click.stop="exportToExcel('exportContent', 'เสนอกลั่นกรอง')"
          class="mr-1"
          color="green"
        >
          <v-icon>mdi-file-excel</v-icon>&nbsp; Export to excel
        </v-btn>
      </v-toolbar-items>
    </v-system-bar>

    <div v-if="loading" class="text-center pa-10">
      <v-progress-circular indeterminate color="primary" size="60"></v-progress-circular>
      <p class="mt-3">กำลังโหลดข้อมูล...</p>
    </div>

    <div
      v-else
      id="exportContent"
      style="mso-page-orientation: landscape; overflow-x: scroll;"
    >
      <div class="page">
        <div align="center">
          <div class="head">
            สรุปคะแนนการประเมินตัวชี้วัดที่ 7 (7.1 - 7.2)
          </div>
          <div class="head">
            ประกอบการพิจารณาย้ายข้าราชการครูและบุคลากรทางการศึกษา ตำแหน่งผู้บริหารสถานศึกษา
          </div>
          <div class="head">
            ครั้งที่ {{ order_appoints.time_s }}/{{ order_appoints.year_s }}
            จำนวน {{ conditons_transfer_successs.length }} ราย
          </div>
        </div>

        <table class="table" border="1" width="100%" align="center">
          <thead>
            <tr>
              <td class="bold16" rowspan="2" align="center">ที่</td>
              <td class="bold16" rowspan="2" align="center">ชื่อ-นามสกุล</td>
              <td class="bold16" rowspan="2" align="center">สังกัดเดิม</td>
              <td class="bold16" rowspan="2" align="center">สังกัดใหม่</td>
              <td class="bold16" rowspan="2" align="center">สาขา</td>
              <td class="bold16" colspan="5" align="center" style="background-color: #c8e6c9;">
                ตัวชี้วัดที่ 7.1 (20 คะแนน)
              </td>
              <td class="bold16" colspan="5" align="center" style="background-color: #bbdefb;">
                ตัวชี้วัดที่ 7.2 (20 คะแนน)
              </td>
              <td class="bold16" rowspan="2" align="center" style="background-color: #fff9c4;">
                รวม<br>7.1-7.2<br>(40)
              </td>
              <td class="bold16" rowspan="2" align="center">
                คะแนน<br>สอจ.<br>(60)
              </td>
              <td class="bold16" rowspan="2" align="center" style="background-color: #ffcc80;">
                รวม<br>(100)
              </td>
              <td class="bold16" rowspan="2" align="center">สถานะ</td>
              <td class="bold16" rowspan="2" align="center">หมายเหตุ</td>
            </tr>
            <tr>
              <td class="bold16 pa-1" align="center" style="background-color: #c8e6c9;">กน.</td>
              <td class="bold16 pa-1" align="center" style="background-color: #c8e6c9;">วช.</td>
              <td class="bold16 pa-1" align="center" style="background-color: #c8e6c9;">บธ.</td>
              <td class="bold16 pa-1" align="center" style="background-color: #c8e6c9;">ฉท.</td>
              <td class="bold16 pa-1" align="center" style="background-color: #c8e6c9;">สรุป</td>
              <td class="bold16 pa-1" align="center" style="background-color: #bbdefb;">กน.</td>
              <td class="bold16 pa-1" align="center" style="background-color: #bbdefb;">วช.</td>
              <td class="bold16 pa-1" align="center" style="background-color: #bbdefb;">บธ.</td>
              <td class="bold16 pa-1" align="center" style="background-color: #bbdefb;">ฉท.</td>
              <td class="bold16 pa-1" align="center" style="background-color: #bbdefb;">สรุป</td>
            </tr>
          </thead>

          <tbody
            v-for="(item, index) in conditons_transfer_successs"
            :key="item.id_cts"
          >
            <tr>
              <td class="regular16" align="center">{{ index + 1 }}</td>
              <td class="regular16 pa-1" align="left">
                {{ item.title_s }}{{ item.frist_name }} {{ item.last_name }}
              </td>
              <td class="regular16 pa-1" align="center">
                {{ item.college_name_old }}
              </td>
              <td class="regular16 pa-1" align="center">
                {{ item.college_name_new }}
              </td>
              <td class="regular16 pa-1" align="left">
                {{ item.ctsid_branch }} : {{ item.branch_name }}
              </td>

              <td class="regular16 pa-1" align="center">{{ formatScore(item.doccon_1_com1) }}</td>
              <td class="regular16 pa-1" align="center">{{ formatScore(item.doccon_1_com2) }}</td>
              <td class="regular16 pa-1" align="center">{{ formatScore(item.doccon_1_com3) }}</td>
              <td class="regular16 pa-1" align="center">{{ formatScore(item.doccon_1_com4) }}</td>
              <td class="bold16 pa-1" align="center" style="background-color: #f5f5f5;">
                {{ formatScore(item.doccon_1) }}
              </td>

              <td class="regular16 pa-1" align="center">{{ formatScore(item.doccon_14_com1) }}</td>
              <td class="regular16 pa-1" align="center">{{ formatScore(item.doccon_14_com2) }}</td>
              <td class="regular16 pa-1" align="center">{{ formatScore(item.doccon_14_com3) }}</td>
              <td class="regular16 pa-1" align="center">{{ formatScore(item.doccon_14_com4) }}</td>
              <td class="bold16 pa-1" align="center" style="background-color: #f5f5f5;">
                {{ formatScore(item.doccon_14) }}
              </td>

              <td class="bold16 pa-1" align="center" style="background-color: #fff9c4;">
                {{ formatScore(item.score_1420) }}
              </td>

              <td class="regular16 pa-1" align="center">
                {{ formatScore(item.tpvecprovince_score) }}
              </td>

              <td class="bold16 pa-1" align="center" style="background-color: #ffcc80;">
                {{ calcGrandTotal(item) }}
              </td>

              <td class="regular16 pa-1" align="center">
                <v-chip
                  v-if="item.status_document === 'complete'"
                  color="green" dark small
                >ครบ</v-chip>
                <v-chip
                  v-else-if="item.status_document === 'incomplete'"
                  color="warning" dark small
                >ไม่ครบ</v-chip>
                <v-chip
                  v-else-if="item.status_document === 'do_not'"
                  color="red" dark small
                >ไม่จัดส่ง</v-chip>
                <span v-else>-</span>
              </td>

              <td class="regular16 pa-1" align="center">
                <v-chip
                  :color="getRemark(item).color"
                  dark small
                >
                  {{ getRemark(item).text }}
                </v-chip>
              </td>
            </tr>

            <tr
              v-for="(itemchild, i) in item.transference_locations"
              :key="'child-' + item.id_cts + '-' + i"
              style="background-color: #fff3e0;"
            >
              <td class="regular16" align="center"></td>
              <td class="regular16 pa-1" align="left" style="padding-left: 20px !important;">
                ↳ {{ itemchild.tranPersonel }}
              </td>
              <td class="regular16 pa-1" align="center">
                {{ itemchild.college_name }}
              </td>
              <td class="regular16 pa-1" align="center"></td>
              <td class="regular16 pa-1" align="left">
                {{ itemchild.tlid_branch }} : {{ itemchild.branch_name }}
              </td>

              <td class="regular16 pa-1" align="center">{{ formatScore(itemchild.doccon_1_com1) }}</td>
              <td class="regular16 pa-1" align="center">{{ formatScore(itemchild.doccon_1_com2) }}</td>
              <td class="regular16 pa-1" align="center">{{ formatScore(itemchild.doccon_1_com3) }}</td>
              <td class="regular16 pa-1" align="center">{{ formatScore(itemchild.doccon_1_com4) }}</td>
              <td class="bold16 pa-1" align="center" style="background-color: #f5f5f5;">
                {{ formatScore(itemchild.doccon_1) }}
              </td>

              <td class="regular16 pa-1" align="center">{{ formatScore(itemchild.doccon_14_com1) }}</td>
              <td class="regular16 pa-1" align="center">{{ formatScore(itemchild.doccon_14_com2) }}</td>
              <td class="regular16 pa-1" align="center">{{ formatScore(itemchild.doccon_14_com3) }}</td>
              <td class="regular16 pa-1" align="center">{{ formatScore(itemchild.doccon_14_com4) }}</td>
              <td class="bold16 pa-1" align="center" style="background-color: #f5f5f5;">
                {{ formatScore(itemchild.doccon_14) }}
              </td>

              <td class="bold16 pa-1" align="center" style="background-color: #fff9c4;">
                {{ formatScore(itemchild.score_1420) }}
              </td>

              <td class="regular16 pa-1" align="center">
                {{ formatScore(itemchild.tpvecprovince_score) }}
              </td>

              <td class="bold16 pa-1" align="center" style="background-color: #ffcc80;">
                {{ calcGrandTotal(itemchild) }}
              </td>

              <td class="regular16 pa-1" align="center">
                <v-chip
                  v-if="itemchild.status_document === 'complete'"
                  color="green" dark small
                >ครบ</v-chip>
                <v-chip
                  v-else-if="itemchild.status_document === 'incomplete'"
                  color="warning" dark small
                >ไม่ครบ</v-chip>
                <v-chip
                  v-else-if="itemchild.status_document === 'do_not'"
                  color="red" dark small
                >ไม่จัดส่ง</v-chip>
                <span v-else>-</span>
              </td>

              <td class="regular16 pa-1" align="center">
                <span class="regular12" style="color: #888;">คู่แข่ง</span>
              </td>
            </tr>

            <tr v-if="item.other_branch_competitors && item.other_branch_competitors.length > 0">
              <td colspan="20" class="bold16 pa-1" style="background-color: #E3F2FD; color: #1565C0; border-left: 4px solid #1565C0;">
                ▸ คู่แข่งสาขาวิชาอื่นที่ขอย้ายเข้าวิทยาลัยเดียวกัน (สาขาที่วิทยาลัยเปิดรับ แต่ไม่ได้รับพิจารณา)
                จำนวน {{ item.other_branch_competitors.length }} ราย
              </td>
            </tr>

            <tr
              v-for="(comp, cIdx) in item.other_branch_competitors"
              :key="'comp-' + item.id_cts + '-' + comp.tlid_card + '-' + cIdx"
              style="background-color: #E3F2FD;"
            >
              <td class="regular16" align="center">{{ cIdx + 1 }}</td>
              <td class="regular16 pa-1" align="left" style="padding-left: 20px !important;">
                ↳ {{ comp.tranPersonel }}
              </td>
              <td class="regular16 pa-1" align="center">
                {{ comp.college_name_current }}
              </td>
              <td class="regular16 pa-1" align="center"></td>
              <td class="regular16 pa-1" align="left">
                {{ comp.tlid_branch }} : {{ comp.branch_name }}
              </td>

              <td class="regular16 pa-1" align="center">{{ formatScore(comp.doccon_1_com1) }}</td>
              <td class="regular16 pa-1" align="center">{{ formatScore(comp.doccon_1_com2) }}</td>
              <td class="regular16 pa-1" align="center">{{ formatScore(comp.doccon_1_com3) }}</td>
              <td class="regular16 pa-1" align="center">{{ formatScore(comp.doccon_1_com4) }}</td>
              <td class="bold16 pa-1" align="center" style="background-color: #f5f5f5;">
                {{ formatScore(comp.doccon_1) }}
              </td>

              <td class="regular16 pa-1" align="center">{{ formatScore(comp.doccon_14_com1) }}</td>
              <td class="regular16 pa-1" align="center">{{ formatScore(comp.doccon_14_com2) }}</td>
              <td class="regular16 pa-1" align="center">{{ formatScore(comp.doccon_14_com3) }}</td>
              <td class="regular16 pa-1" align="center">{{ formatScore(comp.doccon_14_com4) }}</td>
              <td class="bold16 pa-1" align="center" style="background-color: #f5f5f5;">
                {{ formatScore(comp.doccon_14) }}
              </td>

              <td class="bold16 pa-1" align="center" style="background-color: #fff9c4;">
                {{ formatScore(comp.score_1420) }}
              </td>

              <td class="regular16 pa-1" align="center">
                {{ formatScore(comp.tpvecprovince_score) }}
              </td>

              <td class="bold16 pa-1" align="center" style="background-color: #ffcc80;">
                {{ calcGrandTotal(comp) }}
              </td>

              <td class="regular16 pa-1" align="center">
                <v-chip v-if="comp.status_document === 'complete'" color="green" dark small>ครบ</v-chip>
                <v-chip v-else-if="comp.status_document === 'incomplete'" color="warning" dark small>ไม่ครบ</v-chip>
                <v-chip v-else-if="comp.status_document === 'do_not'" color="red" dark small>ไม่จัดส่ง</v-chip>
                <span v-else>-</span>
              </td>

              <td class="regular16 pa-1" align="center">
                <v-chip color="#7B1FA2" dark small>สาขาอื่น</v-chip>
              </td>
            </tr>

          </tbody>
        </table>

        <div class="mt-5">
          <table width="100%" style="border: none;">
            <tr>
              <td width="60%" style="border: none;"></td>
              <td width="40%" align="center" style="border: none;">
                <p>ลงชื่อ...........................................................ประธานกรรมการ</p>
                <p>(...........................................................)</p>
                <p>ตำแหน่ง...........................................................</p>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data: () => ({
    ApiKey: "HRvec2021",
    loading: false,
    order_appoints: [],
    order_appointsNum: [],
    conditons_transfer_successs: [],
    conditons_transfer_successsCut: [],
    valid: true
  }),

  async mounted() {
    await this.loadAllData();
  },

  methods: {
    // ===== โหลดข้อมูลทั้งหมด =====
    async loadAllData() {
      this.loading = true;
      try {
        await this.order_appointQueryAll();
        await Promise.all([
          this.order_appoint_num(),
          this.conditons_transfer_successQueryAll(),
          this.conditons_transfer_successCutQueryAll()
        ]);
      } catch (error) {
        console.error("โหลดข้อมูลผิดพลาด:", error);
      } finally {
        this.loading = false;
      }
    },

    // ===== Format คะแนน =====
    formatScore(val) {
      if (val === null || val === undefined || val === '') return '-';
      const num = parseFloat(val);
      if (isNaN(num)) return '-';
      return num % 1 === 0 ? num.toString() : num.toFixed(2);
    },

    // ===== คำนวณคะแนนรวมทั้งหมด =====
    calcGrandTotal(item) {
      const total = parseFloat(item.tpvecprovince_score || 0) +
        parseFloat(item.score_1420 || 0);
      return total % 1 === 0 ? total.toString() : total.toFixed(2);
    },

    // ===== คำนวณคะแนนรวม (ตัวเลข) สำหรับเปรียบเทียบ =====
    calcTotalScore(person) {
      return parseFloat(
        parseFloat(person.tpvecprovince_score || 0) +
        parseFloat(person.score_1420 || 0)
      );
    },

    // ===== กำหนดข้อความหมายเหตุ =====
    getRemark(item) {
      const competitors = item.transference_locations || [];

      // ไม่มีคู่แข่ง = ยื่นย้ายรายเดียว
      if (competitors.length === 0) {
        return { text: 'ยื่นย้ายรายเดียว', color: 'blue' };
      }

      // มีคู่แข่ง — เปรียบเทียบคะแนน
      const myScore = this.calcTotalScore(item);

      // นับจำนวนคู่แข่งที่คะแนนสูงกว่า
      const higherCount = competitors.filter(c =>
        this.calcTotalScore(c) > myScore
      ).length;

      // อันดับ = 1 + จำนวนคนที่สูงกว่า
      const rank = 1 + higherCount;

      let color = 'orange';
      if (rank === 1) color = 'green';

      return {
        text: `คะแนนอันดับ ${rank}`,
        color: color
      };
    },

    // ===== API Calls =====
    async order_appointQueryAll() {
      let data = {
        ApiKey: this.ApiKey,
        id_oa: this.id_url
      };
      let result = await this.$http.post("order_appoint.php", data);
      this.order_appoints = result.data;
    },

    async order_appoint_num() {
      let result = await this.$http.post("order_appoint.php", {
        ApiKey: this.ApiKey,
        id_oa: this.id_url,
        time_s: this.order_appoints.time_s,
        year_s: this.order_appoints.year_s,
        name_position: "ครู"
      });
      this.order_appointsNum = result.data;
    },

    async conditons_transfer_successQueryAll() {
      let data = {
        ApiKey: this.ApiKey,
        time_s: this.order_appoints.time_s,
        year_s: this.order_appoints.year_s,
        name_position: "ครู",
        ctsstatus_selectfrist: "ok"
      };
      let result = await this.$http.post(
        "conditons_transfer_success_filter_3.php",
        data
      );
      this.conditons_transfer_successs = result.data;
    },

    async conditons_transfer_successCutQueryAll() {
      let result = await this.$http.post(
        "conditons_transfer_success_filter_3.php",
        {
          ApiKey: this.ApiKey,
          time_s: this.order_appoints.time_s,
          year_s: this.order_appoints.year_s,
          name_position: "ครู",
          ctsstatus_selectsecord: "transfer"
        }
      );
      this.conditons_transfer_successsCut = result.data;
    },

    // ===== Export =====
    exportToExcel(element, filename) {
      var preHtml =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:excel' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Excel</title></head><body>";
      var postHtml = "</body></html>";
      var html =
        preHtml + document.getElementById(element).innerHTML + postHtml;
      var blob = new Blob(["\ufeff", html], { type: "application/msexcel" });
      var url =
        "data:application/vnd.ms-excel;charset=utf-8," +
        encodeURIComponent(html);
      filename = filename ? filename + ".xls" : "document.xls";
      var downloadLink = document.createElement("a");
      document.body.appendChild(downloadLink);
      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        downloadLink.href = url;
        downloadLink.download = filename;
        downloadLink.click();
      }
      document.body.removeChild(downloadLink);
    }
  },

  props: {
    source: String
  },

  computed: {
    url_result() {
      let result = window.location.href;
      let split_s = result.split("/");
      return split_s[6];
    },
    position_url() {
      let result = this.url_result.slice(6);
      return result === "teach" ? "ครู" : "บริหาร";
    },
    id_url() {
      let result = this.url_result;
      return result[0];
    }
  }
};
</script>

<style>
@import url(
  https://fonts.googleapis.com/css?family=Prompt:400,300|Roboto:400,300&subset=latin,thai
);

body {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 16px;
  font-weight: 250;
}

* {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  box-sizing: border-box;
}

.table, .th, .td {
  border-bottom: 0.5px solid black;
  border-top: 1px solid black;
  border-left: 1px solid black;
  border-right: 1px solid black;
  border-collapse: collapse;
  line-height: 1;
}

td, th {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
}

.page {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 16pt;
  width: 60cm;
  min-height: 21cm;
  border: 1px #d3d3d3 solid;
  border-radius: 5px;
  background: white;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
  padding: 0.5cm;
}

.head {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 16pt;
  font-weight: bold;
  line-height: 1;
}

.regular12 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 14pt;
}

.regular16 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 16pt;
}

.bold16 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 16pt;
  font-weight: bold;
}

@media print {
  .page {
    border: initial;
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
    padding: 1cm 1cm 1cm 1.5cm;
  }
  .noprint {
    display: none;
  }
}
</style>